import { StateTimeline } from 'chargePoint/types/stateTimeline'
import { Loadable, useApiGetFunction } from 'common'
import { useEffect, useState } from 'react'

// [timestamp, isConnected]
export type ControllerConnectionState = [string, boolean]

export interface ControllerConnectionStateResponse {
    deviceId: string
    chargePointId: string
    data: ControllerConnectionState[]
}

export default function useControllerConnectionState(
    controllerId: string,
    startDate: string,
    endDate: string
): Loadable<StateTimeline> {
    const get = useApiGetFunction<ControllerConnectionStateResponse>()
    const [state, setState] = useState<Loadable<StateTimeline>>({
        status: 'loading',
    })

    useEffect(() => {
        get(
            `time-series/${controllerId}/controller-connection-state?startDate=${startDate}&endDate=${endDate}`
        )
            .then((res) =>
                setState({
                    status: 'success',
                    data: {
                        name: 'Connection',
                        stateNames: ['Disconnected', 'Connected'],
                        stateColors: ['#a00', '#0a0'],
                        points: res.data
                            .sort((a, b) => a[0].localeCompare(b[0]))
                            .map((x) => ({ date: x[0], stateOrdinal: Number(x[1]) })),
                    },
                })
            )
            .catch((err) => setState({ status: 'error', error: err }))
    }, [controllerId, startDate, endDate, get])

    return state
}
